<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.critical datapoints") }}
        <span v-if="this.formPage == 'Critical data inventory'"> : <b>{{ criticalInfo.processId }}</b> - <b>{{ criticalInfo.processName }}</b></span>
       
      </h4>
    </template>
    <template #body>
       <div v-if="!criticalInfo || Object.keys(criticalInfo).length === 0" class="text-center py-2">
        <h6 class="text-muted">No Data Found</h6>
      </div>
      <!-- Threshold Section -->
       <div v-else>
        <div class="col-md-12 p-1 h-100 d-flex flex-column" v-if="this.formPage == 'ThresholdPopup'">
            <div class="card mb-2 patient-summary">
                <div class="card-header">
                  <span>Risk ID :</span><h6 class="d-inline px-2"> {{ criticalInfo.riskID }} </h6>
                  <span>Risk Name :</span><h6 class="d-inline px-2"> {{ criticalInfo.riskName }} </h6> 
                  <span>Version:</span><h6 class="d-inline px-2"> {{ criticalInfo.version }}   </h6>
                </div>
                <div class="card-header"> Threshold Ranges </div>
                <div class="card-body">
                <div class="row">
                    <div class="col-md-4 border-end" v-for="threshold in criticalInfo.thresholds" :key="threshold.min">
                    <!-- <h6>Low</h6> -->
                    <dl class="row mb-0" >
                      <dt class="col-sm-5">Min</dt> <dd class="col-sm-7"> {{ threshold.min }} </dd>
                      <dt class="col-sm-5">Max</dt> <dd class="col-sm-7"> {{ threshold.max }} </dd>
                      <dt class="col-sm-5">Probability</dt> <dd class="col-sm-7"> {{ threshold.probability }} </dd>
                      <dt class="col-sm-5">Detectibility</dt> <dd class="col-sm-7"> {{ threshold.detectibility }} </dd>
                      <dt class="col-sm-5">Impact</dt> <dd class="col-sm-7"> {{ threshold.impact }} </dd>    
                    </dl>
                    </div>
                </div>
                </div>
            </div>  
        </div>
        
        <!-- End of threshold section -->
        <div class="table-responsive custom-dark-table-wrapper">
        <table class="table table-striped dark-table-head mb-0">
            <thead>
                <tr>
                <th> {{ $t("navigations.eCRF form") }} </th>
                <th> {{ $t("navigations.data points") }} </th>
                </tr>
            </thead>
            <tbody v-if="this.formPage == 'ThresholdPopup'">
                <tr v-for="item in criticalInfo.criticalPoints" :key="item.id">
                    <td> {{  item.templateName }}</td>
                    <td > 
                      <span v-for="fieldName in item.fieldnames" :key="fieldName"> 
                        {{ fieldName+", "}}
                      </span>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="this.formPage == 'Critical data inventory'">
                <tr v-for="item in criticalInfo.criticalData" :key="item.id">
                    <td> {{  item.templateName }}</td>
                    <td> 
                      <span v-for="fieldName in item.fieldNames" :key="fieldName"> 
                        {{ fieldName+", "}}
                      </span>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        </div>
    </template>
  </customModal>
</template>

<script src="./CriticalDPModal.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.card {
  border-radius: 6px !important;
  border: 1px solid #dee2e6;
}
.patient-summary dl dt {
  font-weight: 500;
  color: #6c757d;
}

.patient-summary dl dd {
  margin-bottom: 0.1rem;
}
.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  border-radius: 6px 6px 0px 0px !important;
}
.card-header h6{
    font-size: .8rem !important;
    font-weight: 600 !important;
    color: #007bff;
}
</style>